<template>
    <div class="login-component auth-component">
        <div class="auth-container">

            <div class="auth-container__title">
                <h3>Login</h3>
            </div>

            <div class="auth-container__content">
                <form v-on:submit="login">
                    <div class="form-group">
                        <label>Username</label>
                        <input type="text" name="username" v-model="username" required="required" class="form-control" />
                    </div>

                    <div class="form-group">
                        <label>Password</label>
                        <input type="password" name="password" v-model="password" required="required" class="form-control" />
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary form-control">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js';

export default {
    name: 'AuthLogin',
    data: function() {
        return {
            username: '',
            password: ''
        }
    },
    computed: {
        ...mapStores(useAuthStore)
    },
    methods: {
        login(e) {
            e.preventDefault();
            this.authStore.authenticateUser(this.username, this.password)
              .then(result => {
                  if (result === true) {
                      this.$router.push('/users')
                  }
              })
        }
    }
}
</script>

<style lang="scss" scoped>
.auth-component {
	box-sizing: border-box;
	padding: 80px 0;
	width: 100%;
	height: auto;
	min-height: 100vh;
	background: #f1f1f1;
	font-size: $font-size-small;
}

.auth-container {

	h1, h2, h3, h4, h5 {
		margin: 0;
		font-weight: normal;
	}

	width: 90%;
	max-width: 475px;
	margin: 0 auto;
	position: relative;

	&__logo {
		text-align: center;
	}

	&__title {

		text-align:center;
		align-items: baseline;
		margin-top: 80px;

		h1, h2, h3 {
			display: inline-block;
			font-size: 2.2rem;
			line-height: 2.5rem;
			color: $secondary-color;
			margin-bottom: 1.5rem;
		}

	}

	&__content {
		margin: 0px auto;
		background-color: $white-color;
		padding: 50px 72px;
		border-radius: 15px;
		box-shadow: 0px 5px 15px rgba(0, 0, 0, .10);
	}

	.auth-bottom-links {
		display: flex;
		justify-content: space-between;

		a {
			display: inline-block;
			padding: 3px 0 2px;
			border-bottom: 1px solid $brand-color;

			&, &:hover {
				text-decoration: none;
				color: $text-color;
			}
		}
	}

	.form-group {
		margin-bottom: 22px;
		position: relative;

		label {
			display: block;
			margin-bottom: 10px;
		}

		.form-control {
			width: 100%;
			height: 46px;
			line-height: 30px;
			padding: 8px;
			border-radius: 8px;
			border: 1px solid rgba(0, 0, 0, .35);
			outline: transparent;
			box-sizing: border-box;
			background-color: $white-color;

			&[type="submit"], &[type="submit"] {
				background-color: $brand-color;
				border: 1px solid $brand-color;
				font-weight: $font-weight-bold;
				font-size: $font-size;
        color: $white-color;
			}

			&.has-error {
				border: 1px solid red;
			}
		}
	}

	.input-icon {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 16px;
		height: 16px;
		margin-right: 15px;
		margin-bottom: 14px;
	}
	.input-icon + .form-control {
		padding-right: 40px;
	}

}

@media (max-width: 575px) {
	.auth-container__content {
		padding: 40px 10%;
	}
	.auth-container__title {
		margin-top: 50px;
	}
	.auth-component {
		padding: 60px 0;
	}
}
</style>
